import React from "react";

/**
 * Non-Operational marker glyph.
 *
 * Unlike most icons in this folder the fill is currentColor and props are spread onto
 * the <svg>, so the colour can come from org config via the wrapper's `color`. Do not
 * bake a fill in here.
 */
// `name` is destructured away because CustomIcon spreads its whole props
// object, which would otherwise put name="status-..." on the <svg>.
const WrenchIcon = ({ size = 10, name, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fill="currentColor"
            d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
        />
    </svg>
);

export default WrenchIcon;
